// src/pages/About/index.js
import React from 'react';
import './style.css';

const teamMembers = [
	{
		name: "Fools Dream",
		role: "Lead Gaming Reviewer",
		bio: "For him, it's all just about the fun.",
		specialties: ["RPGs", "Action Games", "FPS"],
		image: "https://ix-marketing.imgix.net/hero-image_solutions.png?auto=format,compress&w=1074"
	},
	{
		name: "Ms EvilArt",
		role: "Film & TV Critic",
		bio: "Former film school professor turned critic, specializing in cinematography and storytelling.",
		specialties: ["Independent Cinema", "TV Drama", "Visual Storytelling"],
		image: "https://yakirafinejewellery.com/cdn/shop/files/Yakira_Logo_1.png?height=628&pad_color=ffffff&v=1734180264&width=1200"
	},
	{
		name: "Trajor",
		role: "Content Editor",
		bio: "The man. The myth. The legend. He's nuts.",
		specialties: ["Industry Analysis", "Content Strategy", "Editorial"],
		image: "https://static.wikia.nocookie.net/minecraft_gamepedia/images/9/91/Oak_Trapdoor_JE4_BE2.png/revision/latest?cb=20201206122909"
	}
];

const stats = [
	{ label: "Reviews Published", value: "4+", icon: "⭐" },
	{ label: "Monthly Readers", value: "0+", icon: "👥" },
	{ label: "Industry Fun", value: "12", icon: "🏆" },
	{ label: "Years of Experience", value: "Mixed", icon: "❤️" }
];

const About = () => {
	return (
		<div className="aboutpage-container">
			<div className="aboutpage-content">
				{/* Hero Section */}
				<div className="aboutpage-hero">
					<div className="hero-icon-container">
						<span className="hero-icon">⭐</span>
					</div>
					<h1>About Rant Hub</h1>
					<p className="hero-text">
						We're passionate critics dedicated to providing honest, in-depth reviews of games, movies,
						and TV shows. Our mission is to help you discover your next favorite entertainment experience
						through thoughtful analysis and genuine recommendations.
					</p>
				</div>

				{/* Stats */}
				<div className="aboutpage-stats">
					{stats.map((stat) => (
						<div key={stat.label} className="stat-card">
							<div className="stat-icon">{stat.icon}</div>
							<div className="stat-value">{stat.value}</div>
							<div className="stat-label">{stat.label}</div>
						</div>
					))}
				</div>

				{/* Our Story */}
				<div className="aboutpage-story">
					<h2>Our Story</h2>
					<div className="story-box">
						<p className="story-paragraph">
							ReviewScope began in 2016 as a small blog run by gaming enthusiasts who were frustrated
							with the lack of honest, comprehensive reviews in the entertainment space. What started
							as weekend hobby writing has grown into a trusted source for entertainment criticism.
						</p>
						<p className="story-paragraph">
							We believe that great entertainment deserves thoughtful analysis. Whether it's a
							blockbuster AAA game, an indie film festival darling, or the latest streaming sensation,
							we approach each review with the same level of care and attention to detail.
						</p>
						<p>
							Our reviews go beyond simple scores – we dig deep into what makes entertainment tick,
							examining everything from technical performance to emotional impact. We're here to help
							you make informed decisions about how to spend your precious free time.
						</p>
					</div>
				</div>

				{/* Team Section */}
				<div className="aboutpage-team">
					<h2>Meet Our Team</h2>
					<div className="team-grid">
						{teamMembers.map((member) => (
							<div key={member.name} className="team-member-card">
								<div className="team-image-wrapper">
									<img
										src={member.image}
										alt={member.name}
									/>
								</div>
								<div className="team-member-content">
									<h3>{member.name}</h3>
									<p className="member-role">{member.role}</p>
									<p className="member-bio">{member.bio}</p>
									<div className="member-specialties">
										{member.specialties.map((specialty) => (
											<span key={specialty} className="specialty-tag">
												{specialty}
											</span>
										))}
									</div>
								</div>
							</div>
						))}
					</div>
				</div>

				{/* Our Values */}
				<div className="aboutpage-values">
					<h2>Our Values</h2>
					<div className="values-grid">
						<div className="value-card">
							<h3 className="value-title value-title--blue">Honest Reviews</h3>
							<p>
								We never pull punches or inflate scores for clicks. Our reviews reflect our genuine
								opinions, whether positive or negative.
							</p>
						</div>
						{/* <div className="value-card">
							<h3 className="value-title value-title--green">Deep Analysis</h3>
							<p>
								Surface-level impressions aren't enough. We spend significant time with each piece
								of entertainment to provide comprehensive insights.
							</p>
						</div> */}
						<div className="value-card">
							<h3 className="value-title value-title--orange">Diverse Perspectives</h3>
							<p>
								Our team brings varied backgrounds and tastes to ensure we cover entertainment
								from multiple viewpoints.
							</p>
						</div>
						<div className="value-card">
							<h3 className="value-title value-title--indigo">Community First</h3>
							<p>
								We write for real people looking for their next great entertainment experience,
								not industry insiders or corporate partners.
							</p>
						</div>
					</div>
				</div>

				{/* Contact CTA */}
				<div className="aboutpage-contact">
					<h3>Want to Work With Us?</h3>
					<p className="contact-text">
						We're always interested in connecting with fellow critics, developers, and entertainment
						enthusiasts. Reach out if you'd like to collaborate or have story ideas.
					</p>
					<div className="contact-buttons">
						<a href="/contact" className="contact-button contact-button--primary">
							<span>❤️</span>
							Get in Touch
						</a>
						<a href="mailto:info@moonfacetechs.com" className="contact-button contact-button--secondary">
							<span>🔗</span>
							Email Us
						</a>
					</div>
				</div>
			</div>
		</div>
	);
};

export default About;